import React from 'react';
import { ComponentStory, ComponentMeta } from '@storybook/react';
import Button from './Button';

import { ReactComponent as HomeIcon } from '../../../../assets/home.svg';
import { ReactComponent as ArrowBackIcon } from '../../../../assets/arrow_back.svg';

// More on default export: https://storybook.js.org/docs/react/writing-stories/introduction#default-export
export default {
  // title: 'ATOMS_COMPONENTS/Button',
  component: Button,
  // decorators: [
  //   (Story) => (
  //     <Paper sx={{ m: 4, p: 4, textAlign: 'center' }}>{Story()}</Paper>
  //   ),
  // ],
  // // More on argTypes: https://storybook.js.org/docs/react/api/argtypes
  // argTypes: {
  //   backgroundColor: { control: 'color' },
  // },
} as ComponentMeta<typeof Button>;

// More on component templates: https://storybook.js.org/docs/react/writing-stories/introduction#using-args
const Template: ComponentStory<typeof Button> = (args) => <Button {...args} />;

export const ContainedPrimary = Template.bind({});
// More on args: https://storybook.js.org/docs/react/writing-stories/args
ContainedPrimary.args = {
  variant: 'contained',
  children: 'Click me',
};

export const ContainedSecondary = Template.bind({});
// More on args: https://storybook.js.org/docs/react/writing-stories/args
ContainedSecondary.args = {
  ...ContainedPrimary.args,
  variant: 'contained-gray',
};

export const ContainedLarge = Template.bind({});
ContainedLarge.args = {
  ...ContainedPrimary.args,
  size: 'large',
};

export const ContainedSmall = Template.bind({});
ContainedSmall.args = {
  ...ContainedPrimary.args,
  size: 'small',
};
export const ContainedRounded = Template.bind({});
ContainedRounded.args = {
  ...ContainedPrimary.args,
  rounded: true,
};

export const Text = Template.bind({});
Text.args = {
  ...ContainedPrimary.args,
  variant: 'text',
};

export const IconButton = Template.bind({});
IconButton.args = {
  ...ContainedPrimary.args,
  children: <HomeIcon />,
};

export const IconButtonSecondary = Template.bind({});
IconButtonSecondary.args = {
  ...ContainedSecondary.args,
  children: <ArrowBackIcon style={{ height: '28px', padding: '5px' }} />,
};
